module.exports = __webpack_public_path__ + "static/media/pubg3.e9f9a02b.png";